import axios from 'axios';

export default axios.create({
  baseURL: `https://api.newrelic.com/v2`,
  headers: {
    'X-Api-Key': '09f581e1b85774c335ca8de6edbe2634f1b648092ce9220'
  }
});
